// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientBlock_root__2sYWg","header":"PatientBlock_header__2U8V4","label":"PatientBlock_label__1_BgI","option":"PatientBlock_option__3urw7"};